export default "__VITE_ASSET__jM4FnP7Z__"